module.exports = __webpack_public_path__ + "static/media/minneapolis-desktop.1fc355c2.webp";